import { render } from "./DevelopmentEntry.vue?vue&type=template&id=52206f82&scoped=true"
import script from "./DevelopmentEntry.vue?vue&type=script&lang=ts"
export * from "./DevelopmentEntry.vue?vue&type=script&lang=ts"

import "./DevelopmentEntry.vue?vue&type=style&index=0&id=52206f82&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-52206f82"

export default script